import { FileItem } from "ng2-file-upload";

export class MediaFileModel {
  constructor(
    public id: string,
    public url: string,
    public fileType: string,
    public fileItem: FileItem
  ) {
    this.id = id;
    this.url = url;
    this.fileType = fileType;
    this.fileItem = fileItem;
  }
}
